import { captureException } from '@fabric-app/compat/capabilities/sentry';
import { useClientLayoutEffect } from '@fabric-app/hooks/useClientLayoutEffect';
import { ensureError } from '@fabric-app/utils/guards';
import { useQueryClient } from '@tanstack/react-query';
import { useRef } from 'react';
import { v4 } from 'uuid';

const PENDING_MUTATIONS_KEY = "pendingMutations";
const getPendingMutations = () => {
  const pendingMutations = localStorage.getItem(PENDING_MUTATIONS_KEY);
  return pendingMutations ? JSON.parse(pendingMutations) : [];
};
const setPendingMutations = (pendingMutations) => {
  localStorage.setItem(PENDING_MUTATIONS_KEY, JSON.stringify(pendingMutations));
};
const addPendingMutation = (queryKeys) => {
  const mutationId = v4();
  const pendingMutations = getPendingMutations();
  const newPendingMutation = {
    id: mutationId,
    queryKeys
  };
  setPendingMutations([
    ...pendingMutations,
    newPendingMutation
  ]);
  return () => {
    setTimeout(() => {
      const updatedPendingMutations = getPendingMutations().filter((mutation) => mutation.id !== mutationId);
      setPendingMutations(updatedPendingMutations);
    }, 500);
  };
};
const useInvalidatePendingMutations = () => {
  const ranOnce = useRef(false);
  const queryClient = useQueryClient();
  useClientLayoutEffect(() => {
    if (ranOnce.current) return;
    ranOnce.current = true;
    const onFullyLoaded = () => {
      const pendingMutations = getPendingMutations();
      for (const mutation of pendingMutations) {
        for (const queryKey of mutation.queryKeys) {
          queryClient.invalidateQueries({
            queryKey,
            exact: false,
            type: "active"
          }).catch((e) => {
            captureException(ensureError(e), {
              level: "error",
              extra: {
                queryKey
              }
            });
          });
        }
      }
      setPendingMutations([]);
    };
    window.addEventListener("load", onFullyLoaded);
    return () => {
      window.removeEventListener("load", onFullyLoaded);
    };
  }, [
    queryClient
  ]);
};

export { addPendingMutation, useInvalidatePendingMutations };
//# sourceMappingURL=pending.js.map
